import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { StatusValidacaoImportacaoXmlNFeEntradaEnum } from '@shared/enums/repo-dfe/status-validacao-importacao-xml-nfe-entrada.enum';
import { ValidacaoImportacaoLinha } from '../../validacao-importacao-linha';

@Component({
  selector: 'app-importar-xml-validacao-step',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule, AlertCardComponent],
  templateUrl: './importar-xml-validacao-step.component.html',
  styleUrls: ['./importar-xml-validacao-step.component.css'],
})
export class ImportarXmlValidacaoStepComponent {
  @Input() validacoes: ValidacaoImportacaoLinha[] = [];
  @Input() isProcessando = false;
  @Input() isErro = false;
  @Input() validacaoComErro: ValidacaoImportacaoLinha | undefined;
  @Input() mensagemErroGeral?: string;

  isValidacaoSucesso(validacao: ValidacaoImportacaoLinha): boolean {
    return validacao.idStatus === StatusValidacaoImportacaoXmlNFeEntradaEnum.Sucesso;
  }

  isValidacaoAlerta(validacao: ValidacaoImportacaoLinha): boolean {
    return validacao.idStatus === StatusValidacaoImportacaoXmlNFeEntradaEnum.Alerta;
  }

  isValidacaoErro(validacao: ValidacaoImportacaoLinha): boolean {
    return validacao.idStatus === StatusValidacaoImportacaoXmlNFeEntradaEnum.Erro;
  }
}
